var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6698 15.517C16.6698 20.2021 12.9383 23.9998 8.33503 23.9998C3.73181 23.9998 0 20.2021 0 15.517C0 10.8318 4.66738 7.75995 7.47013 2.46434C7.84068 1.76413 8.82882 1.76413 9.19937 2.46434C12.0021 7.75995 16.6695 10.8985 16.6695 15.517H16.6698Z",
    fill: "#9478DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.0006 9.68611C24.0006 12.8848 21.5619 15.5042 18.4737 15.7231C18.498 15.4515 18.5102 15.1776 18.5102 14.9018C18.5102 13.5002 18.1227 12.1561 17.2914 10.672C16.5678 9.3806 15.5961 8.1407 14.5672 6.82744C14.2719 6.45058 13.974 6.07084 13.6777 5.6842C14.8097 4.09275 16.3287 2.47052 17.4378 0.374773C17.7021 -0.12464 18.407 -0.12464 18.6713 0.374773C20.6707 4.15259 24.0006 6.39189 24.0006 9.68669V9.68611Z",
    fill: "#9478DD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0339 14.5415V16.5644C12.0339 16.8858 11.7778 17.1464 11.4621 17.1464H9.90077V18.7284C9.90077 19.0497 9.64469 19.3103 9.32897 19.3103H7.34139C7.02567 19.3103 6.76959 19.0497 6.76959 18.7284V17.1464H5.20852C4.8928 17.1464 4.63672 16.8858 4.63672 16.5644V14.5415C4.63672 14.2201 4.8928 13.9595 5.20852 13.9595H6.76959V12.3634C6.76959 12.0421 7.02567 11.7815 7.34139 11.7815H9.32897C9.64469 11.7815 9.90077 12.0421 9.90077 12.3634V13.9595H11.4621C11.7778 13.9595 12.0339 14.2201 12.0339 14.5415Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropPlus);
export default __webpack_public_path__ + "static/media/DropPlus.91a4de809a7646210147c08ae24e2c5e.svg";
export { ForwardRef as ReactComponent };